import React, { useEffect } from 'react';
import withInit from 'WithInit';
import ConvertPdfToWordLandingPageFullWidthUploadPanel from './ConvertPdfToWordLandingPageFullWidthUploadPanel';

const ConvertPdfToWordLandingPage = () => {
  useEffect(() => {
    window.Upload.activateUploadButtonById('uploadPDFLarge');
  }, []);

  return (
    <div
      className={`
        convert-pdf-to-word-container
        large-upload-panel-mock-freewrite-wrapper
        large-upload-panel-wrapper`
      }
    >
      <img
        src="/images/convert-pdf-to-word-no-buttons-toolbar-web.png"
        alt="Mock Free Write Background"
        className="large-upload-panel-mock-freewrite-bg-img img-lg"
      />
      <img
        src="/images/convert-pdf-to-word-no-buttons-toolbar-mobile.png"
        alt="Mock Free Write Background"
        className="large-upload-panel-mock-freewrite-bg-img img-xs"
      />
      <ConvertPdfToWordLandingPageFullWidthUploadPanel />
    </div>
  );
};

const ConvertPdfToWordLandingPageWithInit = withInit(ConvertPdfToWordLandingPage);

export default ConvertPdfToWordLandingPageWithInit;



// WEBPACK FOOTER //
// ./src-react/ConvertPdfToWordLandingPage/index.jsx